export const FREQUENCY_DEFAULTS = {
  Daily: "RRULE:FREQ=DAILY;BYDAY=MO,TU,WE,TH,FR",
  Weekly: "RRULE:FREQ=WEEKLY;INTERVAL=1;BYDAY=MO",
  Monthly: "RRULE:FREQ=MONTHLY;INTERVAL=1;BYSETPOS=1;BYDAY=MO",
};
